<p-toolbar>
    <span *ngFor="let item of facilityAllocationTypes; let i = index">
        <div class="flex items-center">
            <p-radioButton inputId="label" name="rgAllocationType" [value]="item.value"
                [(ngModel)]="allocationType" (ngModelChange)="
                        this.messages = [
                            {
                                severity: 'warn',
                                detail: 'Changing Allocation type affects all allocations'
                            }
                        ]
                    "></p-radioButton>
            <label for="label" class="ml-2">{{item.label}}</label>
        </div>

    </span>
    <p-messages [(value)]="messages"></p-messages>
</p-toolbar>
<div class="card" [hidden]="allocationType == 1">
    <p-table stripedRows [value]="items"
        dataKey="id"
        #dtFacilityAllocations
        [style]="{ 'min-width': '100%' }"
        editMode="row"
        [scrollable]="true"
        scrollHeight="50vh"
    >
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" style="text-align: center">
                    <div class="tabulator-placeholder">
                        <span> No Data Available </span>
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #header let-item>
            <tr>
                <!-- Edit -->
                <th class="edit-cell"></th>
                <!-- status-->
                <th class="status-cell">
                    <i
                        class="pi pi-exclamation-circle"
                        title="Status"
                    ></i>
                </th>
                <!-- Cost Pool -->
                <th pSortableColumn="CCratecodedesc">
                    {{ columnHeader }}
                    Cost Pool
                    <p-sortIcon
                        pSortableColumn="CCratecodedesc"
                        field="CCratecodedesc"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                    <p-columnFilter type="text" matchMode="contains" field="CCratecodedesc" display="menu" class="ml-auto" />
                </th>
                <!-- Percentage -->
                <th pSortableColumn="Allocationamount">
                    {{ columnHeader }}
                    <p-sortIcon
                        pSortableColumn="Allocationamount"
                        field="Allocationamount"
                        ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"
                    ></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template
            #body
            let-item
            let-edit="editing"
            let-ri="rowIndex"
        >
            <tr [pSelectableRow]="item"
                [pEditableRow]="item"
                data-id="row-{{ item.id }}"
            >
                <!-- Edit -->
                <td class="edit-cell">
                    <button
                        *ngIf="
                            !edit &&
                            (!editing?.id || editing?.id === item?.id)
                        "
                        pButton
                        type="button"
                        pInitEditableRow
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-text"
                        (click)="onRowEditInit(item)"
                        title="Edit"
                    ></button>
                    <button
                        *ngIf="edit"
                        pButton
                        type="button"
                        pSaveEditableRow
                        icon="pi pi-check"
                        class="
                            p-button-rounded p-button-text p-button-success
                        "
                        (click)="onRowEditSave(item)"
                    ></button>
                    <button
                        *ngIf="edit"
                        pButton
                        type="button"
                        pCancelEditableRow
                        icon="pi pi-times"
                        class="
                            p-button-rounded p-button-text p-button-danger
                        "
                        (click)="onRowEditCancel(item)"
                    ></button>
                </td>
                <!-- Status-->
                <td class="status-cell">
                    <div (click)="onStatusClick(item)" class="status-cell">
                        <ef-status-icon
                            [status]="item?.Status?.StatusCode"
                            [message]="item?.Status?.Message"
                        ></ef-status-icon>
                    </div>
                </td>
                <!-- Cost Pool -->
                <td class="disabled">
                    {{ item?.CCratecodedesc }}
                </td>
                <!-- Percentage -->
                <td>
                    <p-cellEditor>
                        <ng-template #input>
                            <div>
                                <input pInputText [(ngModel)]="item.Allocationamount" />
                            </div>
                        </ng-template>
                        <ng-template #output>
                            <div>
                                {{ item?.Allocationamount }}
                            </div>
                        </ng-template>
                    </p-cellEditor>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<div>
    <div class="alert alert-warning" *ngIf="false">
        To be utilized, allocation percentages must total 100%
    </div>
</div>
